export const TEXTS = {
  RATES_TABLE_PRICES_TITLE: (title: string) => `Цены тарифа «${title}»`,
  RATES_BLOCK_RATES_REQUEST_BILL_TEXT: 'Запросить счет',
};
